<template>
    <div id="subjects">
        <AppBreadCrumb :paths="[{ title: 'Cluster Dashboard' }]" :select="true">
            <a-button :disabled="cleaning" class="actionButtonBreadcrumb" style="margin-right: 8px" @click="clean">
                <a-spin v-if="cleaning" />
                <md-icon v-else>refresh</md-icon>
                {{ $t("message.clean") }}
            </a-button>
        </AppBreadCrumb>
        <b-container fluid>
            <div class="row">
                <div class="col-3">
                    <ECharts id="chart-2" ref="chart" :option="tabletCpuGauge" style="height: 400px; width: 400px" />
                </div>
                <div class="col-6">
                    <ECharts id="chart-1" ref="chart" :option="socketCpuGauge" />
                </div>
                <div class="col-3">
                    <ECharts id="chart-4" ref="chart" :option="masterCpuGauge" style="height: 400px; width: 400px" />
                </div>
            </div>
            <div id="chart">
                <a-button style="background-color: lightsteelblue" @click="toggleDetail">{{
                    isVisiblePieChart == false ? $t("message.showDetail") : $t("message.hideDetail")
                }}</a-button>

                <ECharts
                    id="chart-2"
                    ref="chart"
                    :option="pie"
                    style="height: calc(100vh - 200px)"
                    v-show="isVisiblePieChart"
                />
            </div>

            <div class="row">
                <div class="col-12" style="display: flex; justify-content: flex-end; align-items: center">
                    <b-button v-b-modal.logModal class="" type="submit" variant="primary" @click="showLog('tablet')">
                        <template> Tablet Logs</template>
                    </b-button>
                    <b-button
                        v-b-modal.logModal
                        class="ml-2"
                        type="submit"
                        variant="primary"
                        @click="showLog('master')"
                    >
                        <template> Master Logs</template>
                    </b-button>
                    <b-button
                        v-b-modal.logModal
                        class="ml-2"
                        type="submit"
                        variant="primary"
                        @click="showLog('socket')"
                    >
                        <template> Socket Logs</template>
                    </b-button>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <b-form class="d-flex flex-column justify-content-center" @submit.prevent="startLoadTest">
                        <b-row>
                            <b-col md="2">
                                <md-field
                                    v-tippy="{
                                        followCursor: true,
                                        placement: 'bottom-end',
                                        theme: isDarkMode ? 'light-border' : 'google',
                                    }"
                                    content="Alabileceği değerler:  development|stage|production"
                                    :class="{
                                        'md-invalid': errors.first($t('message.target')) != null,
                                    }"
                                    disabled
                                >
                                    <label>{{ $t("message.target") }}</label>
                                    <md-input
                                        v-model="loadTest.target"
                                        v-validate="'required'"
                                        :name="$t('message.target')"
                                    ></md-input>
                                    <span class="md-error">{{ errors.first($t("message.target")) }}</span>
                                </md-field>
                            </b-col>
                            <b-col md="2">
                                <md-field
                                    v-tippy="{
                                        followCursor: true,
                                        placement: 'bottom-end',
                                        theme: isDarkMode ? 'light-border' : 'google',
                                    }"
                                    :class="{
                                        'md-invalid': errors.first($t('message.duration')) != null,
                                    }"
                                    content="Yük testi kaç saniye sürecekse buraya giriyoruz"
                                >
                                    <label>{{ $t("message.duration") }}</label>
                                    <md-input
                                        v-model="loadTest.duration"
                                        v-validate="'required'"
                                        :name="$t('message.duration')"
                                    ></md-input>
                                    <span class="md-error">{{ errors.first($t("message.duration")) }}</span>
                                </md-field>
                            </b-col>
                            <b-col md="2">
                                <md-field
                                    v-tippy="{
                                        followCursor: true,
                                        placement: 'bottom-end',
                                        theme: isDarkMode ? 'light-border' : 'google',
                                    }"
                                    :class="{
                                        'md-invalid': errors.first($t('message.arrivalCount')) != null,
                                    }"
                                    content="Yük testi boyunca toplam kaç bot girmesinizi istiyorsanız adetini yazınız"
                                >
                                    <label>{{ $t("message.arrivalCount") }}</label>
                                    <md-input
                                        v-model="loadTest.arrivalCount"
                                        v-validate="'required'"
                                        :name="$t('message.arrivalCount')"
                                    ></md-input>
                                    <span class="md-error">{{ errors.first($t("message.arrivalCount")) }}</span>
                                </md-field>
                            </b-col>
                            <b-col md="2">
                                <md-field
                                    v-tippy="{
                                        followCursor: true,
                                        placement: 'bottom-end',
                                        theme: isDarkMode ? 'light-border' : 'google',
                                    }"
                                    :class="{
                                        'md-invalid': errors.first($t('message.bootMaxLife')) != null,
                                    }"
                                    content="Sisteme giren bir bot kaç saniye boyunca ayakta kalmasını istiyorsanız onu yazın. 10 ve 10'un katları olsun"
                                >
                                    <label>{{ $t("message.bootMaxLife") }}</label>
                                    <md-input
                                        v-model="loadTest.bootMaxLife"
                                        v-validate="'required'"
                                        :name="$t('message.bootMaxLife')"
                                    ></md-input>
                                    <span class="md-error">{{ errors.first($t("message.bootMaxLife")) }}</span>
                                </md-field>
                            </b-col>
                            <b-col md="4" style="display: flex; justify-content: start; align-items: center">
                                <b-button class="w-100" type="submit" variant="primary">
                                    <template>
                                        {{ $t("message.startLoadTest") }}
                                    </template>
                                </b-button>
                                <b-button class="ml-2 w-100" type="button" variant="warning" @click="stopLoadTest">
                                    <template>
                                        {{ $t("message.stopLoadTest") }}
                                    </template>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <a-table
                        :key="'vtable-' + renderCount"
                        :columns="cols()"
                        :dataSource="getRows()"
                        :locale="{
                            emptyText: $t('message.noClusterInstanceFound'),
                        }"
                        :pagination="false"
                        class="custom-table2"
                        rowKey="_id"
                        @change="tableChange"
                    >
                        <div :key="'idSlot' + $i18n.locale" :slot="'idSlot'" slot-scope="data, item">
                            {{ $_.takeRight(item.instanceId, 3).join("") }}
                        </div>
                        <div :key="'socketCountSlot' + $i18n.locale" :slot="'socketCountSlot'" slot-scope="data, item">
                            <div
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                    theme: isDarkMode ? 'light-border' : 'google',
                                }"
                                :content="siteSocketCountWithSiteNameToolTipDesc()"
                            >
                                {{ item.socketCount }}
                            </div>
                        </div>
                        <div :slot="'masterSlot'" slot-scope="data, item">
                            <md-icon
                                v-if="item.leader"
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                    theme: isDarkMode ? 'light-border' : 'google',
                                }"
                                content="Bu sunucu bağlı olduğu cluster'da lider konumdadır."
                                style="color: green"
                                >coronavirus
                            </md-icon>
                        </div>
                        <div :key="'readySlot' + $i18n.locale" :slot="'readySlot'" slot-scope="data, item">
                            <md-icon
                                v-if="item.ready"
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                    theme: isDarkMode ? 'light-border' : 'google',
                                }"
                                content="Bu sunucu cluster'a bağlanmış hazır durumdadır."
                                style="color: green"
                                >done_all
                            </md-icon>
                            <md-icon
                                v-else
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                    theme: isDarkMode ? 'light-border' : 'google',
                                }"
                                content="Bu sunucu henüz cluster'a bağlanamamış hazır değildir."
                                style="color: red"
                                >done
                            </md-icon>
                        </div>
                        <div
                            :key="'circuitBreakerSlot' + $i18n.locale"
                            :slot="'circuitBreakerSlot'"
                            slot-scope="data, item"
                        >
                            <md-icon
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                    theme: isDarkMode ? 'light-border' : 'google',
                                }"
                                :content="
                                    item.circuitBreaker && item.microService === 'socket'
                                        ? 'Bu sunucu devre kırıcı aktiftir. Trafiğe kapalıdır'
                                        : 'Bu sunucuda devre kırıcı kapalıdır. Trafik serbesttir.'
                                "
                                :style="{
                                    color: item.circuitBreaker && item.microService === 'socket' ? 'red' : 'green',
                                }"
                                >traffic
                            </md-icon>
                        </div>
                        <div :key="'cpuSlot' + $i18n.locale" :slot="'cpuSlot'" slot-scope="data, item">
                            {{
                                parseFloat((item.cpu.load * 100).toFixed(2))
                                    .toString()
                                    .concat("%")
                            }}
                        </div>
                        <div :key="'uptime' + $i18n.locale" :slot="'uptimeSlot'" slot-scope="data, item">
                            <span
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                    theme: isDarkMode ? 'light-border' : 'google',
                                }"
                                :content="`Bu sunucunun yaşam süresi: ${$moment
                                    .duration(item.uptime, 'seconds')
                                    .locale('tr')
                                    .humanize()}`"
                            >
                                {{ item.uptime }}
                            </span>
                        </div>
                        <div :key="'actionsSlot' + $i18n.locale" :slot="'actionsSlot'" slot-scope="data, item">
                            <div class="d-flex w-100">
                                <md-button
                                    v-tippy="{
                                        followCursor: true,
                                        placement: 'bottom-end',
                                        theme: isDarkMode ? 'light-border' : 'google',
                                    }"
                                    class="md-icon-button"
                                    content="Stress Testini Başlat"
                                    @click="() => startStressTest(item)"
                                >
                                    <md-icon style="color: red">local_fire_department</md-icon>
                                </md-button>
                                <md-button class="md-icon-button" @click="() => killStressTest(item)">
                                    <md-icon
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                            theme: isDarkMode ? 'light-border' : 'google',
                                        }"
                                        content="Stress Testini Bitir"
                                        style="color: green"
                                        >ac_unit
                                    </md-icon>
                                </md-button>
                                <md-button
                                    v-tippy="{
                                        followCursor: true,
                                        placement: 'bottom-end',
                                        theme: isDarkMode ? 'light-border' : 'google',
                                    }"
                                    class="md-icon-button"
                                    content="Kaynak İzleme Ekranı"
                                    @click="() => monitor(item)"
                                >
                                    <md-icon style="color: teal">memory</md-icon>
                                </md-button>
                                <md-button
                                    v-b-modal.connectModal
                                    v-tippy="{
                                        followCursor: true,
                                        placement: 'bottom-end',
                                        theme: isDarkMode ? 'light-border' : 'google',
                                    }"
                                    class="md-icon-button"
                                    content="Connect To Instance"
                                    @click="() => connect(item)"
                                >
                                    <md-icon style="color: orange">electrical_services</md-icon>
                                </md-button>
                                <md-button
                                    v-b-modal.logModal
                                    v-tippy="{
                                        followCursor: true,
                                        placement: 'bottom-end',
                                        theme: isDarkMode ? 'light-border' : 'google',
                                    }"
                                    class="md-icon-button"
                                    content="Show Log Only Instance"
                                    @click="() => showInstanceLog(item)"
                                >
                                    <md-icon style="color: teal">text_snippet</md-icon>
                                </md-button>
                                <md-button
                                    v-tippy="{
                                        followCursor: true,
                                        placement: 'bottom-end',
                                        theme: isDarkMode ? 'light-border' : 'google',
                                    }"
                                    class="md-icon-button"
                                    content="Shutdown Server"
                                    @click="() => shutdown(item)"
                                >
                                    <md-icon style="color: red">power_settings_new</md-icon>
                                </md-button>
                                <md-button
                                    v-tippy="{
                                        followCursor: true,
                                        placement: 'bottom-end',
                                        theme: isDarkMode ? 'light-border' : 'google',
                                    }"
                                    class="md-icon-button"
                                    content="Restart Server"
                                    @click="() => restart(item)"
                                >
                                    <md-icon style="color: red">restart_alt</md-icon>
                                </md-button>
                            </div>
                        </div>
                    </a-table>
                </div>
            </div>
            <b-modal
                id="monitorModal"
                centered
                hide-footer
                hide-header
                hide-header-close
                size="huge"
                title="Node Monitoring"
            >
                <iframe v-if="netDataUrl" :src="netDataUrl" style="width: 100%; height: 90vh" />
            </b-modal>
            <b-modal id="logModal" centered hide-footer hide-header hide-header-close size="huge" title="Log Viewer">
                <iframe
                    v-if="currentElasticSearchUrl"
                    :src="currentElasticSearchUrl"
                    style="width: 100%; height: 90vh"
                />
            </b-modal>
            <b-modal id="connectModal" centered hide-footer size="lg" title="Connect To Instance">
                <p v-if="connectStr">{{ connectStr }}</p>
            </b-modal>
        </b-container>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPencilAlt, faPlusCircle, faSpinner, faTimes } from "@fortawesome/free-solid-svg-icons";
import { log2 } from "../../utils/log2";
import AppBreadCrumb from "../../components/common/AppBreadCrumb";
import * as _ from "lodash";
import ChatBar from "../../components/ChatBar";
import { sendSocketMessage, socketMessageStream } from "../../utils/socketStream";
import { tableSorter } from "../../utils/utils";
import ActionEdit from "../../components/svg/ActionEdit";
import ActionDelete from "../../components/svg/ActionDelete";
import Pagination from "../../components/Pagination";
import { filter, first, map } from "rxjs/operators";
import createGaugeOptions from "../Reports/data/createGaugeOptions";
import createSocketGaugeOptions from "../Reports/data/createSocketGaugeOptions";
import { createComponent } from "echarts-for-vue";
import echarts from "echarts";
import { clean } from "../../api/site";
import pie from "../Reports/data/pie";

library.add(faPencilAlt, faTimes, faPlusCircle, faSpinner);
const log = log2("ClusterDashboard");

export default {
    name: "ClusterDashboard",
    components: {
        AppBreadCrumb,
        ChatBar,
        ActionEdit,
        ActionDelete,
        Pagination,
        ECharts: createComponent({ echarts }),
    },
    data() {
        return {
            cleaning: false,
            isVisiblePieChart: false,
            pie: pie([
                { name: "aa", value: 1 },
                { name: "bb", value: 10 },
            ]),
            loading: false,
            cluster: {
                socket: [],
                tablet: [],
                master: [],
            },
            socketCpuGauge: createSocketGaugeOptions("Socket Cluster CPU", 0),
            tabletCpuGauge: createGaugeOptions("Tablet Cluster CPU", 0),
            masterCpuGauge: createGaugeOptions("Master Cluster CPU", 0),
            timerId: undefined,
            connectStr: undefined,
            renderCount: 0,
            netDataUrl: undefined,
            pageSizes: ["10", "25", "50", "100"],
            currentSort: {
                columnKey: "instanceId",
                order: "ascend",
            },
            loadTest: {
                target: process.env.ENVIRONMENT,
                duration: 100,
                arrivalCount: 100,
                siteId: undefined,
                bootMaxLife: 60,
            },
            currentElasticSearchUrl: undefined,
            elasticSearchUrls: {
                development: {
                    tablet: "https://search-supsisdev-ajsgbp7zr7pqqv2aq7ywkdd34a.eu-central-1.es.amazonaws.com/_plugin/kibana/app/kibana#/discover/2806ee70-50f3-11eb-946e-89eae8284fb8?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-15m,to:now))&_a=(columns:!(fields.siteId,fields.instanceId,fields.environment,fields.project,message,fields.metaJSON,fields._level),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.environment,negate:!f,params:(query:stage),type:phrase),query:(match_phrase:(fields.environment:stage))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.project,negate:!f,params:(query:tablet),type:phrase),query:(match_phrase:(fields.project:tablet)))),index:e4236900-0b05-11eb-94cc-7b603827f969,interval:auto,query:(language:lucene,query:''),sort:!())&embed=true",
                    master: "https://search-supsisdev-ajsgbp7zr7pqqv2aq7ywkdd34a.eu-central-1.es.amazonaws.com/_plugin/kibana/app/kibana#/discover/dfe58c90-50f3-11eb-af25-0d74a89673b0?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-15m,to:now))&_a=(columns:!(fields.siteId,fields.instanceId,fields.environment,fields.project,message,fields.metaJSON,fields._level),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.environment,negate:!f,params:(query:stage),type:phrase),query:(match_phrase:(fields.environment:stage))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.project,negate:!f,params:(query:master),type:phrase),query:(match_phrase:(fields.project:master)))),index:e4236900-0b05-11eb-94cc-7b603827f969,interval:auto,query:(language:lucene,query:''),sort:!())&embed=true",
                    socket: "https://search-supsisdev-ajsgbp7zr7pqqv2aq7ywkdd34a.eu-central-1.es.amazonaws.com/_plugin/kibana/app/kibana#/discover/eb2f6c70-50f7-11eb-af25-0d74a89673b0?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-15m,to:now))&_a=(columns:!(fields.siteId,fields.instanceId,fields.environment,fields.project,message,fields.metaJSON,fields._level),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.environment,negate:!f,params:(query:stage),type:phrase),query:(match_phrase:(fields.environment:stage))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.project,negate:!f,params:(query:socket),type:phrase),query:(match_phrase:(fields.project:socket)))),index:e4236900-0b05-11eb-94cc-7b603827f969,interval:auto,query:(language:lucene,query:''),sort:!())&embed=true",
                    instanceLog: (id) =>
                        "https://search-supsisdev-ajsgbp7zr7pqqv2aq7ywkdd34a.eu-central-1.es.amazonaws.com/_plugin/kibana/app/kibana#/discover/2806ee70-50f3-11eb-946e-89eae8284fb8?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-15m,to:now))&_a=(columns:!(fields.siteId,fields.environment,fields.project,message,fields.metaJSON,fields._level),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.environment,negate:!f,params:(query:stage),type:phrase),query:(match_phrase:(fields.environment:stage))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.instanceId,negate:!f,params:(query:d4c9183f-c0c1-4ced-8c90-efc14abe1a00),type:phrase),query:(match_phrase:(fields.instanceId:'__id__')))),index:e4236900-0b05-11eb-94cc-7b603827f969,interval:auto,query:(language:lucene,query:''),sort:!())&embed=true".replace(
                            "__id__",
                            id
                        ),
                },
                stage: {
                    tablet: "https://search-supsisdev-ajsgbp7zr7pqqv2aq7ywkdd34a.eu-central-1.es.amazonaws.com/_plugin/kibana/app/kibana#/discover/2806ee70-50f3-11eb-946e-89eae8284fb8?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-15m,to:now))&_a=(columns:!(fields.siteId,fields.instanceId,fields.environment,fields.project,message,fields.metaJSON,fields._level),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.environment,negate:!f,params:(query:stage),type:phrase),query:(match_phrase:(fields.environment:stage))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.project,negate:!f,params:(query:tablet),type:phrase),query:(match_phrase:(fields.project:tablet)))),index:e4236900-0b05-11eb-94cc-7b603827f969,interval:auto,query:(language:lucene,query:''),sort:!())&embed=true",
                    master: "https://search-supsisdev-ajsgbp7zr7pqqv2aq7ywkdd34a.eu-central-1.es.amazonaws.com/_plugin/kibana/app/kibana#/discover/dfe58c90-50f3-11eb-af25-0d74a89673b0?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-15m,to:now))&_a=(columns:!(fields.siteId,fields.instanceId,fields.environment,fields.project,message,fields.metaJSON,fields._level),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.environment,negate:!f,params:(query:stage),type:phrase),query:(match_phrase:(fields.environment:stage))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.project,negate:!f,params:(query:master),type:phrase),query:(match_phrase:(fields.project:master)))),index:e4236900-0b05-11eb-94cc-7b603827f969,interval:auto,query:(language:lucene,query:''),sort:!())&embed=true",
                    socket: "https://search-supsisdev-ajsgbp7zr7pqqv2aq7ywkdd34a.eu-central-1.es.amazonaws.com/_plugin/kibana/app/kibana#/discover/eb2f6c70-50f7-11eb-af25-0d74a89673b0?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-15m,to:now))&_a=(columns:!(fields.siteId,fields.instanceId,fields.environment,fields.project,message,fields.metaJSON,fields._level),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.environment,negate:!f,params:(query:stage),type:phrase),query:(match_phrase:(fields.environment:stage))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.project,negate:!f,params:(query:socket),type:phrase),query:(match_phrase:(fields.project:socket)))),index:e4236900-0b05-11eb-94cc-7b603827f969,interval:auto,query:(language:lucene,query:''),sort:!())&embed=true",
                    instanceLog: (id) =>
                        "https://search-supsisdev-ajsgbp7zr7pqqv2aq7ywkdd34a.eu-central-1.es.amazonaws.com/_plugin/kibana/app/kibana#/discover/2806ee70-50f3-11eb-946e-89eae8284fb8?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-15m,to:now))&_a=(columns:!(fields.siteId,fields.environment,fields.project,message,fields.metaJSON,fields._level),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.environment,negate:!f,params:(query:stage),type:phrase),query:(match_phrase:(fields.environment:stage))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.instanceId,negate:!f,params:(query:d4c9183f-c0c1-4ced-8c90-efc14abe1a00),type:phrase),query:(match_phrase:(fields.instanceId:'__id__')))),index:e4236900-0b05-11eb-94cc-7b603827f969,interval:auto,query:(language:lucene,query:''),sort:!())&embed=true".replace(
                            "__id__",
                            id
                        ),
                },
                production: {
                    tablet: "https://search-supsisdev-ajsgbp7zr7pqqv2aq7ywkdd34a.eu-central-1.es.amazonaws.com/_plugin/kibana/app/kibana#/discover/983f91b0-5364-11eb-946e-89eae8284fb8?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-15m,to:now))&_a=(columns:!(fields.siteId,fields.instanceId,fields.environment,fields.project,message,fields.metaJSON,fields._level),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.environment,negate:!f,params:(query:production),type:phrase),query:(match_phrase:(fields.environment:production))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.project,negate:!f,params:(query:tablet),type:phrase),query:(match_phrase:(fields.project:tablet)))),index:e4236900-0b05-11eb-94cc-7b603827f969,interval:auto,query:(language:lucene,query:''),sort:!())&embed=true",
                    master: "https://search-supsisdev-ajsgbp7zr7pqqv2aq7ywkdd34a.eu-central-1.es.amazonaws.com/_plugin/kibana/app/kibana#/discover/f69de4f0-5364-11eb-af25-0d74a89673b0?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-15m,to:now))&_a=(columns:!(fields.siteId,fields.instanceId,fields.environment,fields.project,message,fields.metaJSON,fields._level),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.environment,negate:!f,params:(query:production),type:phrase),query:(match_phrase:(fields.environment:production))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.project,negate:!f,params:(query:master),type:phrase),query:(match_phrase:(fields.project:master)))),index:e4236900-0b05-11eb-94cc-7b603827f969,interval:auto,query:(language:lucene,query:''),sort:!())&embed=true",
                    socket: "https://search-supsisdev-ajsgbp7zr7pqqv2aq7ywkdd34a.eu-central-1.es.amazonaws.com/_plugin/kibana/app/kibana#/discover/f69de4f0-5364-11eb-af25-0d74a89673b0?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-15m,to:now))&_a=(columns:!(fields.siteId,fields.instanceId,fields.environment,fields.project,message,fields.metaJSON,fields._level),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.environment,negate:!f,params:(query:production),type:phrase),query:(match_phrase:(fields.environment:production))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.project,negate:!f,params:(query:socket),type:phrase),query:(match_phrase:(fields.project:socket)))),index:e4236900-0b05-11eb-94cc-7b603827f969,interval:auto,query:(language:lucene,query:''),sort:!())&embed=true",
                    instanceLog: (id) =>
                        "https://search-supsisdev-ajsgbp7zr7pqqv2aq7ywkdd34a.eu-central-1.es.amazonaws.com/_plugin/kibana/app/kibana#/discover/2806ee70-50f3-11eb-946e-89eae8284fb8?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-15m,to:now))&_a=(columns:!(fields.siteId,fields.environment,fields.project,message,fields.metaJSON,fields._level),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.environment,negate:!f,params:(query:stage),type:phrase),query:(match_phrase:(fields.environment:production))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e4236900-0b05-11eb-94cc-7b603827f969,key:fields.instanceId,negate:!f,params:(query:d4c9183f-c0c1-4ced-8c90-efc14abe1a00),type:phrase),query:(match_phrase:(fields.instanceId:'__id__')))),index:e4236900-0b05-11eb-94cc-7b603827f969,interval:auto,query:(language:lucene,query:''),sort:!())&embed=true".replace(
                            "__id__",
                            id
                        ),
                },
            },
            cols: () => [
                {
                    dataIndex: "instanceId",
                    title: "ID",
                    scopedSlots: { customRender: "idSlot" },
                    ...tableSorter("instanceId", "string", this.currentSort),
                },
                {
                    dataIndex: "microService",
                    title: "Micro Service",
                    ...tableSorter("microService", "string", this.currentSort),
                },
                {
                    dataIndex: "socketCount",
                    title: "Socket Count",
                    scopedSlots: { customRender: "socketCountSlot" },
                    ...tableSorter("socketCount", "number", this.currentSort),
                },
                {
                    dataIndex: "leader",
                    title: "Leader",
                    scopedSlots: { customRender: "masterSlot" },
                    ...tableSorter("leader", "string", this.currentSort),
                },
                {
                    dataIndex: "uptime",
                    title: "Uptime",
                    scopedSlots: { customRender: "uptimeSlot" },
                    ...tableSorter("uptime", "number", this.currentSort),
                },
                {
                    dataIndex: "ready",
                    title: "Ready",
                    scopedSlots: { customRender: "readySlot" },
                    ...tableSorter("ready", "string", this.currentSort),
                },
                {
                    dataIndex: "circuitBreaker",
                    title: "Circuit Breaker",
                    scopedSlots: { customRender: "circuitBreakerSlot" },
                    ...tableSorter("circuitBreaker", "string", this.currentSort),
                },
                {
                    dataIndex: "cpu.load",
                    title: "CPU",
                    scopedSlots: { customRender: "cpuSlot" },
                    ...tableSorter("cpu.load", "number", this.currentSort),
                },
                {
                    dataIndex: "hostname",
                    title: "Hostname",
                    ...tableSorter("hostname", "string", this.currentSort),
                },
                {
                    title: this.$t("message.transactions"),
                    scopedSlots: { customRender: "actionsSlot" },
                    width: "10%",
                },
            ],
        };
    },
    computed: {
        ...mapState({
            languages: (state) => state.language.languages,
            site: (state) => state.site.site,
            sites: (state) => state.site.sites.data,
            isAdmin: (state) => state.auth.adminUser != null,
            isDarkMode: (state) => state.user.darkMode,
        }),
    },
    methods: {
        ...mapActions({
            getSites: "site/getSites",
        }),
        startLoadTest() {
            this.$validator.validateAll().then((response) => {
                if (response) {
                    this.loadTestStarted = true;
                    const loadTestUrl = process.env.LOAD_TEST_URL + "/start";
                    fetch(loadTestUrl, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(this.loadTest),
                    })
                        .then((res) => {
                            if (res.ok) {
                                this.$toasted.show("Yük testi başlatıldı", {
                                    duration: 3000,
                                    position: "top-right",
                                });
                                this.loadTestStarted = true;
                            } else {
                                this.$toasted.error("Yük Testi Başlatılamadı", {
                                    duration: 3000,
                                    position: "top-right",
                                });
                                this.loadTestStarted = false;
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                            this.$toasted.error("Yük Testi Başlatılamadı", {
                                duration: 3000,
                                position: "top-right",
                            });
                            this.loadTestStarted = false;
                        });
                }
            });
        },
        stopLoadTest() {
            this.$validator.validateAll().then((response) => {
                if (response) {
                    const loadTestUrl = process.env.LOAD_TEST_URL + "/stop";
                    fetch(loadTestUrl, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                    })
                        .then((res) => {
                            if (res.ok) {
                                this.$toasted.show("Yük testi sonlandırıldı", {
                                    duration: 3000,
                                    position: "top-right",
                                });
                                this.loadTestStarted = false;
                            } else {
                                this.$toasted.error("Yük Testi Sonlandırılamadı", {
                                    duration: 3000,
                                    position: "top-right",
                                });
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                            this.$toasted.error("Yük Testi Sonlandırılamadı", {
                                duration: 3000,
                                position: "top-right",
                            });
                        });
                }
            });
        },
        monitor(item) {
            const hostname = item.hostname;
            const url = `http://${hostname}:19999`;
            window.open(url, "_blank");
            // this.netDataUrl = url
        },
        showLog(microService) {
            const url = this.elasticSearchUrls[process.env.ENVIRONMENT][microService];
            this.currentElasticSearchUrl = url;
        },
        siteSocketCountWithSiteName() {
            return this.cluster.socket.reduce((acc, cur) => {
                Object.keys(cur.siteSocketCountMap).forEach((siteId) => {
                    const site = this.sites.find((x) => x._id === siteId);
                    if (site) {
                        if (acc[site.alias] === undefined) acc[site.alias] = cur.siteSocketCountMap[siteId];
                        else acc[site.alias] += cur.siteSocketCountMap[siteId];
                    }
                });
                return acc;
            }, {});
        },
        toggleDetail() {
            let objUnOrdered = this.siteSocketCountWithSiteName();
            // const objUnOrdered = { supsis: 2, sdf: 23, awd: 5, sdcsd: 47, werty: 1, qwer: 40}; //mock data
            const obj = Object.entries(objUnOrdered)
                .sort((first, second) => (first[1] === second[1] ? 0 : first[1] > second[1] ? -1 : 1))
                .reduce((acc, val) => {
                    acc[val[0]] = val[1];
                    return acc;
                }, {});
            this.pie = pie(Object.keys(obj).map((x) => ({ name: x, value: obj[x] })));
            this.isVisiblePieChart = !this.isVisiblePieChart;
        },
        siteSocketCountWithSiteNameToolTipDesc() {
            const countsUnOrdered = this.siteSocketCountWithSiteName();
            // const countsUnOrdered = { supsis: 2, sdf: 23, awd: 5, sdcsd: 47 }; //moch data
            const counts = Object.entries(countsUnOrdered)
                .sort((first, second) => (first[1] === second[1] ? 0 : first[1] > second[1] ? -1 : 1))
                .reduce((acc, val) => {
                    acc[val[0]] = val[1];
                    return acc;
                }, {});
            log("counts", { cuo: countsUnOrdered, c: counts });
            return Object.keys(counts)
                .map((alias) => `${alias} = ${counts[alias]}`)
                .join("\n");
        },
        showInstanceLog(node) {
            const url = this.elasticSearchUrls[process.env.ENVIRONMENT].instanceLog(node.instanceId);
            this.currentElasticSearchUrl = url;
        },
        connect(node) {
            const hostname = node.hostname.replace(".supsis.live", "");
            this.connectStr = `ssh -i "Softcand-Admin.pem" ec2-user@${hostname}.eu-central-1.compute.amazonaws.com`;
        },
        shutdown(node) {
            const hostname = node.hostname;
            const url = `https://${hostname}/shutdown`;
            this.$dialog
                .confirm("Opps , Sunucuyu kapatmak istediğine eminmisin?", {
                    okText: this.$t("message.continue"),
                    cancelText: this.$t("message.cancel"),
                })
                .then(() => {
                    fetch(url)
                        .then((x) => x.json())
                        .then((res) => {
                            if (res.ok) {
                                this.$toasted.show("Sunucu kapatıldı", {
                                    duration: 3000,
                                    position: "top-right",
                                });
                            } else {
                                this.$toasted.error("Sunucu Kapatılamadı", {
                                    duration: 3000,
                                    position: "top-right",
                                });
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                            this.$toasted.error("Sunucu Kapatılamadı", {
                                duration: 3000,
                                position: "top-right",
                            });
                        });
                });
        },
        restart(node) {
            const hostname = node.hostname;
            const url = `https://${hostname}/restart?authSource=admin`;
            this.$dialog
                .confirm("Opps , Sunucuyu restart yapmak istediğine emin misin?", {
                    okText: this.$t("message.continue"),
                    cancelText: this.$t("message.cancel"),
                })
                .then(() => {
                    fetch(url)
                        .then((x) => x.json())
                        .then((res) => {
                            if (res.ok) {
                                this.$toasted.show("Sunucu restart yapıldı", {
                                    duration: 3000,
                                    position: "top-right",
                                });
                            } else {
                                this.$toasted.error("Sunucu Restart Yapılamadı", {
                                    duration: 3000,
                                    position: "top-right",
                                });
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                            this.$toasted.error("Sunucu Restart Yapılamadı", {
                                duration: 3000,
                                position: "top-right",
                            });
                        });
                });
        },
        startStressTest(node) {
            const hostname = node.hostname;
            const url = `https://${hostname}/stress`;
            fetch(url)
                .then((x) => x.json())
                .then((res) => {
                    if (res.ok) {
                        this.$toasted.show("Stress Testi Başlatıldı", {
                            duration: 3000,
                            position: "top-right",
                        });
                    } else {
                        this.$toasted.error("Stress Testi Başlatılamadı", {
                            duration: 3000,
                            position: "top-right",
                        });
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.$toasted.error("Stress Testi Başlatılamadı", {
                        duration: 3000,
                        position: "top-right",
                    });
                });
        },
        killStressTest(node) {
            const hostname = node.hostname;
            const url = `https://${hostname}/stress-kill`;
            fetch(url)
                .then((x) => x.json())
                .then((res) => {
                    if (res.ok) {
                        this.$toasted.show("Stress Testi Sonlandırıldı", {
                            duration: 3000,
                            position: "top-right",
                        });
                    } else {
                        this.$toasted.error("Stress Testi Sonlandırılmadı", {
                            duration: 3000,
                            position: "top-right",
                        });
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.$toasted.error("Stress Testi Sonlandırılmadı", {
                        duration: 3000,
                        position: "top-right",
                    });
                });
        },
        getRows() {
            return [
                ...this.cluster.socket.map((socket) => ({
                    ...socket,
                    microService: "socket",
                    socketCount: _.sum(
                        Object.keys(socket.siteSocketCountMap).map((key) => socket.siteSocketCountMap[key])
                    ),
                })),
                ...this.cluster.tablet.map((tablet) => ({
                    ...tablet,
                    microService: "tablet",
                })),
                ...this.cluster.master.map((master) => ({
                    ...master,
                    microService: "master",
                })),
            ];
        },
        tableChange(pagination, filters, sorter) {
            log("tableChange", { pagination, filters, sorter });
            this.perPage = pagination.pageSize;
            log("tableChange", { pagination, filters, sorter });
            const newSort = {
                columnKey: sorter.columnKey,
                order: sorter.order,
            };
            const oldSort = this.currentSort;
            log("show me current Sort", {
                currentSort: this.currentSort,
                newSort,
            });
            if (!_.isEqual(newSort, oldSort)) {
                this.currentSort = newSort;
                this.renderCount += 1;
                this.$forceUpdate();
            }
        },
        calculateLoadCpu(nodes) {
            const loads = nodes.map((x) => x.cpu.load);
            let result = loads.length ? (_.sum(loads) / loads.length) * 100 : 0;
            result = parseFloat(result.toFixed(2));
            return result;
        },
        calculateChatCount(socket) {
            let totalChatCount = 0;
            socket.forEach((soc) => {
                totalChatCount += _.sum(Object.keys(soc.siteSocketCountMap).map((key) => soc.siteSocketCountMap[key]));
            });
            return totalChatCount;
        },
        setGaugeColors(socketCpuGauge, tabletCpuGauge, masterCpuGauge, color) {
            socketCpuGauge.series[0].title.color = color;
            socketCpuGauge.series[1].title.color = color;
            socketCpuGauge.series[2].title.color = color;
            tabletCpuGauge.series[0].title.color = color;
            masterCpuGauge.series[0].title.color = color;
        },
        async fetchClusterStatus() {
            log("fetchClusterStatus called");
            this.loading = true;
            socketMessageStream
                .pipe(
                    filter((x) => x.cmd === "get_cluster_status_response"),
                    map((x) => x.data),
                    first()
                )
                .toPromise()
                .then((data) => {
                    const { socket, tablet, master } = data;
                    this.cluster = { socket, tablet, master };
                    const socketCpuGauge = _.cloneDeep(this.socketCpuGauge);
                    const tabletCpuGauge = _.cloneDeep(this.tabletCpuGauge);
                    const masterCpuGauge = _.cloneDeep(this.masterCpuGauge);
                    socketCpuGauge.series[0].data[0].value = this.calculateLoadCpu(socket);
                    socketCpuGauge.series[1].data[0].value = socket.length;
                    socketCpuGauge.series[2].data[0].value = this.calculateChatCount(socket);
                    tabletCpuGauge.series[0].data[0].value = this.calculateLoadCpu(tablet);
                    masterCpuGauge.series[0].data[0].value = this.calculateLoadCpu(master);
                    let color = this.isDarkMode ? "#e2e2e2" : "#191D31";
                    this.setGaugeColors(socketCpuGauge, tabletCpuGauge, masterCpuGauge, color);
                    this.socketCpuGauge = socketCpuGauge;
                    this.tabletCpuGauge = tabletCpuGauge;
                    this.masterCpuGauge = masterCpuGauge;
                })
                .finally((x) => {
                    this.loading = false;
                });

            sendSocketMessage("admin get_cluster_status", {});
        },
        get() {
            this.getSites({ perPage: 900, page: 1, extendedMeta: true });
        },
        async clean() {
            this.cleaning = true;
            await clean();
            this.cleaning = false;
        },
    },
    mounted() {
        this.timerId = setInterval(() => {
            this.fetchClusterStatus();
        }, 1 * 1000);
        this.$root.$on("ClusterDashboard", () => {
            this.siteSocketCountWithSiteName();
        });
        this.get();
    },
    beforeDestroy() {
        clearInterval(this.timerId);
    },
    updated() {},
    watch: {
        isDarkMode(newValue) {
            if (newValue === true) {
                this.setGaugeColors(this.socketCpuGauge, this.tabletCpuGauge, this.masterCpuGauge, "#e2e2e2");
            } else {
                this.setGaugeColors(this.socketCpuGauge, this.tabletCpuGauge, this.masterCpuGauge, "#191D31");
            }
        },
    },
};
</script>

<style lang="scss">
#monitorModal,
#logModal {
    .modal-content {
        background: transparent !important;
        padding: 0px 0px 0px 0px !important;
        border: none;
        box-shadow: none;
        -webkit-box-shadow: none;
        border-radius: 0px;
    }
}

.modal .modal-huge {
    max-width: 90vw;
    width: 90vw;
}
</style>
